import{__require as r}from"./function-bind-native.js";var n,t;function i(){if(t)return n;t=1;var i=r(),e=Function.prototype.call;return n=i?e.bind(e):function(){return e.apply(e,arguments)},n}export{i as __require};
//# sourceMappingURL=function-call.js.map
